import { mapGetters } from "vuex";
import { capitalize } from "@/common/functions";

export default {
    props: {
        entry: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters("ThesaurusFilter", ["getSynonymStudies"])
    },
    methods: {
        capitalize,
        synonymStudyLink(html) {
            let result = html.study.trim();

            html.keywords.map(keyword => {
                let regex = new RegExp(keyword, "i");
                let keywordLink =
                    result.indexOf(keyword) === 0 ? this.capitalize(keyword) : keyword;

                result = result.replace(
                    regex,
                    `<a
                        href="/${keyword}"
                        style="font-weight: 600; color: inherit; text-decoration-color: #3A65B5"
                    >
                        ${keywordLink}
                    </a>`
                );
            });

            return this.capitalize(result);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymStudy/SynonymStudy.js